import { useState, useEffect } from "react";

const SplashScreen = ({ onComplete }) => {
  const [phase, setPhase] = useState(0); // 0: hidden, 1: fade in, 2: visible, 3: fade out

  useEffect(() => {
    // Check if already shown this session
    const hasShown = sessionStorage.getItem("splashShown");
    if (hasShown) {
      onComplete();
      return;
    }

    // Start animation sequence
    const timeline = [
      { delay: 100, phase: 1 },    // Fade in
      { delay: 2500, phase: 2 },   // Hold
      { delay: 4000, phase: 3 },   // Fade out
      { delay: 5000, phase: 4 },   // Complete
    ];

    const timers = timeline.map(({ delay, phase: p }) =>
      setTimeout(() => {
        if (p === 4) {
          sessionStorage.setItem("splashShown", "true");
          onComplete();
        } else {
          setPhase(p);
        }
      }, delay)
    );

    return () => timers.forEach(clearTimeout);
  }, [onComplete]);

  if (phase === 0) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-center justify-center bg-black transition-opacity duration-1000 ${
        phase === 3 ? "opacity-0" : "opacity-100"
      }`}
    >
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-[#0A0A0A] to-[#1A1A1A]" />
      
      {/* Subtle gold particles */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-[#C9A227]/30 rounded-full animate-float"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${3 + Math.random() * 2}s`,
            }}
          />
        ))}
      </div>

      {/* Main content */}
      <div
        className={`relative z-10 flex flex-col items-center gap-6 md:gap-8 px-8 transition-all duration-1000 ${
          phase >= 1 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        {/* Logo Equivalencia */}
        <div 
          className={`transition-all duration-700 ${
            phase >= 1 ? "opacity-100 scale-100" : "opacity-0 scale-90"
          }`}
        >
          <h2 className="text-white text-2xl md:text-3xl font-bold tracking-[0.15em] uppercase" style={{
            fontFamily: "'Impact', 'Arial Black', sans-serif",
            letterSpacing: "0.1em"
          }}>
            EQUIVALENCIA
          </h2>
        </div>

        {/* Founder Image */}
        <div className="relative">
          {/* Gold ring */}
          <div className="absolute -inset-3 rounded-full bg-gradient-to-br from-[#C9A227] via-[#D4AF37] to-[#C9A227] opacity-60 blur-md" />
          <div className="absolute -inset-1.5 rounded-full bg-gradient-to-br from-[#C9A227] to-[#D4AF37]" />
          
          {/* Image container */}
          <div className="relative w-44 h-44 md:w-56 md:h-56 rounded-full overflow-hidden border-4 border-black">
            <img
              src="https://customer-assets.emergentagent.com/job_scent-sales-hub/artifacts/zuc956dl_IMG_3999.jpeg"
              alt="Founder"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Text */}
        <div className="text-center">
          <p className="text-[#C9A227] text-xs md:text-sm tracking-[0.4em] uppercase mb-2 font-medium">
            Fondatore
          </p>
          <div className="w-16 h-0.5 bg-gradient-to-r from-transparent via-[#C9A227] to-transparent mx-auto mb-4" />
          <p
            className={`text-white text-xl md:text-2xl font-light tracking-wide transition-all duration-700 delay-300 ${
              phase >= 2 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            Buona giornata di lavoro
          </p>
        </div>
      </div>

      {/* Bottom branding */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <p className="text-gray-600 text-xs tracking-[0.2em] uppercase">
          Equipe Management System
        </p>
      </div>

      {/* Custom badge to cover "Made with Emergent" */}
      <div 
        className="fixed bottom-4 right-4 bg-[#1A1A1A] text-white px-4 py-2 rounded-full shadow-lg flex items-center gap-2 text-sm font-medium border border-[#C9A227]/30"
        style={{ minWidth: '190px', zIndex: 2147483647 }}
      >
        <div className="w-6 h-6 rounded-full bg-[#C9A227] flex items-center justify-center text-black font-bold text-xs">
          E
        </div>
        <span>Equivalencia Team</span>
      </div>

      {/* CSS Animations */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0) scale(1); opacity: 0.3; }
          50% { transform: translateY(-20px) scale(1.5); opacity: 0.6; }
        }
        .animate-float {
          animation: float ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default SplashScreen;
